export function buildSnapshot({ values, content }) {
    return {
        title: values.title ?? "",
        description: values.description ?? "",
        idRegion: values.region?.value ?? values.idRegion ?? null,
        idBusiness: values.business?.value ?? values.idBusiness ?? null,
        active: values.active ?? false,
        content: normalizeContentForPreview(content),
        ...(values.template && {idTemplate: values.template?.value ?? values.idTemplate ?? null}),
        ...(values.type?.value && {type: values.type?.value ?? null}),
        ...(values?.products && {products: values?.products ?? null}),
    };
}

function normalizeContentForPreview(content = []) {
    return content.map(({id, ...rest}) => rest);
}